import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { fetchAllCollectionTags } from '@api/editorialLayout/collectionAdmin';
import { Tag, TextField } from '@components/base';
import useLoad from '@hooks/useLoad';
import { stringComparator } from '@utils/arrayUtils';

export type TagFieldProps = Pick<
  AutocompleteProps<string, true, false, true>,
  'autoFocus' | 'disabled' | 'onChange' | 'open' | 'value'
>;

const TagField: FC<TagFieldProps> = ({ autoFocus, ...rest }) => {
  const { t } = useTranslation();

  const { data: tagOptions = [], isLoading: tagOptionsLoading } = useLoad(
    fetchAllCollectionTags,
    ['collection-tags'],
    { dataTransformer: tags => tags?.filter(tag => !!tag).sort(stringComparator) }
  );

  return (
    <Autocomplete
      disableCloseOnSelect
      freeSolo
      loading={tagOptionsLoading}
      multiple
      options={tagOptions ?? []}
      renderInput={params => <TextField {...params} autoFocus={autoFocus} label={t('tags')} />}
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Tag label={option} soft {...getTagProps({ index })} />
        ))
      }
      {...rest}
    />
  );
};

export default TagField;
